import classNames from 'classnames';
import { ReactNode } from 'react';
import styles from './CardModule.module.scss';

type CardModuleProps = {
  children?: ReactNode;
  className?: string;
  squareOnMobile?: boolean;
  hasDividerBottom?: boolean;
};

const CardModule = ({ children, className, squareOnMobile, hasDividerBottom }: CardModuleProps) => {
  return (
    <div
      className={classNames(styles.container, { [styles.squareOnMobile]: squareOnMobile, [styles.hasDividerBottom]: hasDividerBottom }, className)}
    >
      {children}
    </div>
  );
};

export default CardModule;
